import { ViewConfigInterface } from "../../viewConfig.types"
import { validators } from "react-ocean-forms"

export const readViewStatus: ViewConfigInterface = {
  status: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: true,
    },
  },
}

export const editViewStatus: ViewConfigInterface = {
  status: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
      validators: [validators.required],
    },
  },
}

export const deleteViewStatus: ViewConfigInterface = {
  status: {
    field: {
      disabled: true,
      hidden: false,
      plaintext: false,
    },
  },
}

export const newViewStatus: ViewConfigInterface = {
  status: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
      validators: [validators.required],
    },
  },
}

export const searchViewStatus: ViewConfigInterface = {
  status: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
    },
  },
}

